import { AccountStatementFooter } from './AccountStatementFooter';
import { withI18n } from 'react-i18next';
export default withI18n()(AccountStatementFooter);
